import { create } from "zustand";
import { WelcomeStep } from "core/models/welcome";


type State = {
	step?: WelcomeStep | null;

	setStep: (currentStep?: WelcomeStep | null) => void;
};

export const useStoreWelcome = create<State>((set) => ({
	step: WelcomeStep.One,

	setStep: (currentStep) => set(() => ({ step: currentStep }))
}));